import React, { useEffect } from "react";
import NavbarGuest from "./NavbarGuest";
import Footer from "./Footer";
import useResponsiveFlags from "../hooks/useResponsiveFlags";

export default function ContactHome() {
  const { isMobile, isTablet, isDesktop } = useResponsiveFlags();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return (
    <>
      <div className="fullScreenLayout">
        <NavbarGuest />
        <section
          className="content-home"
          style={{
            padding: isDesktop ? "96px 35px 62px 35px" : "62px 20px 62px 20px",
          }}
        >
          <div
            className={`${!isMobile ? "d-flex justify-content-between" : ""} `}
          >
            <div className="col-lg-6">
              <p className="heading mb-5">Contact</p>
            </div>
            <div
              className="col-lg-6 sub-step features-home"
              style={{ maxWidth: !isMobile ? (isTablet ? "50%" : "38%") : "" }}
            >
              <p>
                <strong>New Customers</strong>
              </p>
              <p>
                Interested customers may reach out by using the contact form
                found at{" "}
                <a href="https://cibermed.com/contact/">
                  Contact Us
                </a>.
              </p>
              <br/>
              <p>
                <strong>Registered Customers</strong>
              </p>
              <p>
                For support with iSort&trade; products, or questions about
                tokens, existing customers may reach out to{" "}
                <a href="mailto:support@cibermed.com">support@cibermed.com</a>.
                Our team will respond in a timely manner.
              </p>
              <p>
                For all other inquiries, please email{" "}
                <a href="mailto:info@cibermed.com">info@cibermed.com</a>.
              </p>
            </div>
          </div>
        </section>
        <Footer />
      </div>
    </>
  );
}
